var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.909,
    height: 30,
    viewBox: "0 0 35.909 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-volume-high",
    "data-name": "Icon ionic-ios-volume-high",
    transform: "translate(-4.535 -6.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    d: "M18.683,10.268a1.452,1.452,0,0,0-.647-.15,1.5,1.5,0,0,0-.938.328l-6.113,4.932H6.035a1.5,1.5,0,0,0-1.5,1.5v7.5a1.5,1.5,0,0,0,1.5,1.5h4.95L17.1,30.8a1.522,1.522,0,0,0,.938.328,1.452,1.452,0,0,0,.647-.15,1.5,1.5,0,0,0,.853-1.35v-18A1.5,1.5,0,0,0,18.683,10.268Z",
    transform: "translate(0 1.122)",
    fill: "#fed700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M33.478,21.75A20.468,20.468,0,0,0,27.346,7.078a1.127,1.127,0,1,0-1.584,1.6,18.219,18.219,0,0,1,5.457,13.07h0a18.257,18.257,0,0,1-5.457,13.07,1.126,1.126,0,0,0-.009,1.594,1.1,1.1,0,0,0,.8.338,1.123,1.123,0,0,0,.788-.328A20.423,20.423,0,0,0,33.478,21.75Z",
    transform: "translate(6.966 0)",
    fill: "#fed700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M28.643,20.778h0A15.227,15.227,0,0,0,24.255,10a1.127,1.127,0,1,0-1.6,1.584,13.015,13.015,0,0,1,3.741,9.2h0a13.015,13.015,0,0,1-3.741,9.2,1.13,1.13,0,0,0,.8,1.922,1.1,1.1,0,0,0,.8-.338,15.313,15.313,0,0,0,4.4-10.791Z",
    transform: "translate(5.932 0.973)",
    fill: "#fed700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    d: "M20.7,12.916a1.127,1.127,0,1,0-1.6,1.584,7.5,7.5,0,0,1,2.156,5.307h0a7.536,7.536,0,0,1-2.156,5.307,1.13,1.13,0,0,0,.8,1.922,1.1,1.1,0,0,0,.8-.338,9.731,9.731,0,0,0,2.8-6.882h0A9.711,9.711,0,0,0,20.7,12.916Z",
    transform: "translate(4.746 1.944)",
    fill: "#fed700"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.e2ba4882c88f4778d409e64dd0e14696.svg";
export { ForwardRef as ReactComponent };